// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".InsertNewItemLabelWidth{width:58px !important}.InsertNewItemLabelWidthForDisplay{width:100px !important}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/menuItems/styles.scss"],"names":[],"mappings":"AAAA,yBACE,qBAAsB,CACvB,mCAEC,sBAAuB","file":"styles.scss","sourcesContent":[".InsertNewItemLabelWidth{\n  width: 58px !important;\n}\n.InsertNewItemLabelWidthForDisplay{\n  width: 100px !important;\n}"]}]);
// Exports
module.exports = exports;
